import { useSuspenseQuery } from '@tanstack/react-query';
import { maskDecimal } from '@givebutter/util';
import { faCircleDollarToSlot, faMoneyBill, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchPledgesStats } from 'api/pledges';
import * as PledgesMetricsItem from 'assets/js/pages/pledges/PledgeMetricsItem';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

const PledgesMetrics = () => {
    const { accountId } = useCurrentAccount();
    const currency = useCurrencySymbol();

    const { data } = useSuspenseQuery({
        queryKey: accountQueryKeys.pledgeStats(accountId),
        queryFn: () => {
            return fetchPledgesStats(accountId);
        },
    });

    return (
        <div className="flex flex-col justify-start gap-4">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                <PledgesMetricsItem.Root>
                    <PledgesMetricsItem.Icon>
                        <FontAwesomeIcon icon={faCircleDollarToSlot} />
                    </PledgesMetricsItem.Icon>
                    <PledgesMetricsItem.Content>
                        <PledgesMetricsItem.Title>
                            Outstanding pledge payments
                        </PledgesMetricsItem.Title>
                        <PledgesMetricsItem.Value>
                            {currency}
                            {maskDecimal(data.outstanding_pledge_payments)}
                        </PledgesMetricsItem.Value>
                    </PledgesMetricsItem.Content>
                </PledgesMetricsItem.Root>
                <PledgesMetricsItem.Root>
                    <PledgesMetricsItem.Icon>
                        <FontAwesomeIcon icon={faMoneyBill} />
                    </PledgesMetricsItem.Icon>
                    <PledgesMetricsItem.Content>
                        <PledgesMetricsItem.Title>
                            Realized pledge payments
                        </PledgesMetricsItem.Title>
                        <PledgesMetricsItem.Value>
                            {currency}
                            {maskDecimal(data.realized_pledge_payments)}
                        </PledgesMetricsItem.Value>
                    </PledgesMetricsItem.Content>
                </PledgesMetricsItem.Root>
                <PledgesMetricsItem.Root>
                    <PledgesMetricsItem.Icon>
                        <FontAwesomeIcon icon={faUsers} />
                    </PledgesMetricsItem.Icon>
                    <PledgesMetricsItem.Content>
                        <PledgesMetricsItem.Title>
                            Number of active pledges
                        </PledgesMetricsItem.Title>
                        <PledgesMetricsItem.Value>
                            {data.active_pledges_count}
                        </PledgesMetricsItem.Value>
                    </PledgesMetricsItem.Content>
                </PledgesMetricsItem.Root>
            </div>
        </div>
    );
};

export { PledgesMetrics };
